// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".getPrize .el-pagination[data-v-909144b0] {\n  margin-top: 20px;\n  text-align: right;\n}\n.getPrize .search[data-v-909144b0] {\n  margin: 20px 0;\n}\n.getPrize .tips[data-v-909144b0] {\n  color: red;\n  font-size: 14px;\n}\n.getPrize .prizeInfo[data-v-909144b0] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.getPrize .prizeInfo li[data-v-909144b0] {\n    width: 50%;\n    margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
